import React, { useState } from "react";
import api from "../lib/api";
import { useI18n } from "../context/I18nContext";

export default function Appointment() {
  const { t } = useI18n();
  const [form, setForm] = useState({
    full_name: "", email: "", phone: "", company: "",
    preferred_date: "", topic: "", message: "",
  });
  const [status, setStatus] = useState("idle");
  const [err, setErr] = useState("");

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      await api.post("/appointments", form);
      setStatus("ok");
      setForm({ full_name: "", email: "", phone: "", company: "", preferred_date: "", topic: "", message: "" });
    } catch (e2) {
      setStatus("error");
      setErr(e2?.response?.data?.detail || "Erreur");
    }
  };

  return (
    <div className="max-w-[1320px] mx-auto px-6 lg:px-10 pt-16 pb-24" data-testid="page-appointment">
      <div className="grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="overline mb-3">Entretien confidentiel</div>
          <h1 className="serif text-5xl md:text-6xl leading-[1.02]">{t("appointment.title")}</h1>
          <p className="mt-4 text-lg text-[var(--gai-grey-700)]">{t("appointment.sub")}</p>
          <div className="mt-10 p-6 border border-[var(--gai-grey-300)]">
            <div className="overline mb-3">Protocole</div>
            <ul className="space-y-2 text-[var(--gai-grey-700)] text-sm leading-relaxed">
              <li>· Demande qualifiée traitée sous 48h.</li>
              <li>· Entretien en présentiel ou visio sécurisée.</li>
              <li>· Confidentialité garantie · NDA sur demande.</li>
            </ul>
          </div>
        </div>

        <form onSubmit={submit} className="lg:col-span-7 space-y-8" data-testid="appt-form">
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="gai-label">{t("appointment.fullName")}</label>
              <input required value={form.full_name} onChange={onChange("full_name")} className="gai-input" data-testid="appt-fullname" />
            </div>
            <div>
              <label className="gai-label">{t("appointment.company")}</label>
              <input value={form.company} onChange={onChange("company")} className="gai-input" data-testid="appt-company" />
            </div>
            <div>
              <label className="gai-label">{t("appointment.email")}</label>
              <input required type="email" value={form.email} onChange={onChange("email")} className="gai-input" data-testid="appt-email" />
            </div>
            <div>
              <label className="gai-label">{t("appointment.phone")}</label>
              <input value={form.phone} onChange={onChange("phone")} className="gai-input" data-testid="appt-phone" />
            </div>
            <div>
              <label className="gai-label">{t("appointment.date")}</label>
              <input required type="date" value={form.preferred_date} onChange={onChange("preferred_date")} className="gai-input" data-testid="appt-date" />
            </div>
            <div>
              <label className="gai-label">{t("appointment.topic")}</label>
              <input required value={form.topic} onChange={onChange("topic")} className="gai-input" data-testid="appt-topic" />
            </div>
          </div>
          <div>
            <label className="gai-label">{t("appointment.message")}</label>
            <textarea rows={5} value={form.message} onChange={onChange("message")} className="gai-input resize-none" data-testid="appt-message" />
          </div>
          <div className="flex items-center gap-4">
            <button disabled={status === "sending"} className="gai-btn-gold" data-testid="appt-submit">
              {status === "sending" ? t("common.sending") : t("appointment.submit")}
            </button>
            {status === "ok" && <span className="text-[var(--gai-red)] text-sm" data-testid="appt-success">{t("appointment.success")}</span>}
            {status === "error" && <span className="text-red-400 text-sm" data-testid="appt-error">{String(err)}</span>}
          </div>
        </form>
      </div>
    </div>
  );
}
